import React, {useEffect, useState} from "react";
import {StyledPreviewModal} from "./PreviewModal.style";
import Banner from "../../../../assets/Login/mcdBanner.png";
import mcdLogo from "../../../../assets/Login/mcdLogo.svg";
import locationIcon from "../../../../assets/Login/locationIcon.svg";
import clockIcon from "../../../../assets/Login/clockIcon.svg";
import deliveryIcon from "../../../../assets/Login/deliveryIcon.svg";
import Button from "components/molecules/Button";
import {useSelector} from "react-redux";

const PreviewModal = ({setCurrentStep, formData}) => {
    const [bannerUrl, setBannerUrl] = useState(null);
    const [logoUrl, setLogoUrl] = useState(null);
    const {businessSetup1} = useSelector(state => state.business);
    const {businessSetup2} = useSelector(state => state.business);

    useEffect(() => {
        if (formData?.step3?.logo) {
            const objectUrl = URL.createObjectURL(formData.step3.logo);
            setLogoUrl(objectUrl);

            return () => URL.revokeObjectURL(objectUrl);
        } else {
            setLogoUrl(null);
        }
    }, [formData?.step3?.logo]);
    useEffect(() => {
        if (formData?.step3?.banner) {
            const objectUrl = URL.createObjectURL(formData.step3.banner);
            setBannerUrl(objectUrl);

            return () => URL.revokeObjectURL(objectUrl);
        } else {
            setBannerUrl(null);
        }
    }, [formData?.step3?.banner, formData?.step3?.logo]);

    const handleSubmit = () => {
        setCurrentStep(4);
    };

    console.log({formData});
    return (
        <StyledPreviewModal>
            <img src={bannerUrl ?? Banner} alt="banner" className="banner" />
            <div className="details-wrap">
                <img src={logoUrl ?? mcdLogo} alt="logo" className="logo" />
                <strong className="title">{businessSetup1?.name ?? "McDonald's Sauchiehall Street"}</strong>
                <span className="location-wrap">
                    <img src={locationIcon} alt="locationIcon" />
                    {businessSetup2?.address?.street_address ?? "123 Culinary Street, Downtown"}
                </span>
                <ul className="category-wrap">
                    {formData?.step1?.categories && formData.step1.categories.length > 0 ? (
                        formData.step1.categories.map((category, index) => (
                            <li key={index}>{category}</li>
                        ))
                    ) : businessSetup1?.categories && businessSetup1.categories.length > 0 ? (
                        businessSetup1.categories.map((category, index) => (
                            <li key={index}>{category}</li>
                        ))
                    ) : (
                        <>
                            <li>Fast Food</li>
                            <li>Italian</li>
                            <li>Chinese</li>
                            <li>Western</li>
                        </>
                    )}
                </ul>
                <div className="info-wrap">
                    <span className="time-wrap">
                        <img src={clockIcon} alt="clockIcon" />
                        {businessSetup1?.deliveryTime?.label}
                    </span>
                    {formData?.step1?.freeDelivery && (
                        <span className="delivery-wrap">
                            <img src={deliveryIcon} alt="deliveryIcon" />
                            Free Delivery
                        </span>
                    )}
                </div>
                <div className="separator"></div>
                <div className="btn-holder">
                    <Button variant="primary" width="343px" onClick={() => handleSubmit()}>
                        Save & Continue
                    </Button>
                </div>
            </div>
        </StyledPreviewModal>
    );
};

export default PreviewModal;
